import product1 from '../assets/product1.jpg';
import product2 from '../assets/product2.jpg';
import product3 from '../assets/product3.jpg';

export const products = [
  {
    id: 1,
    name: '250ml Bilona Ghee',
    gujarati: '250ml બિલોણા ઘી',
    images: [product1, product2, product3],
    features: ['Daily consumption', 'Perfect for small families', 'Fresh & Pure'],
    price: 850,
    size: '250ml',
    description: 'Perfect for daily cooking and consumption. Our 250ml pack is ideal for small families who want to experience the authentic taste of traditional Bilona Ghee.',
    benefits: [
      'Rich in Omega-3 fatty acids',
      'Boosts immunity',
      'Improves digestion',
      'Good for heart health',
      'Enhances brain function'
    ]
  },
  {
    id: 2,
    name: '500ml Bilona Ghee',
    gujarati: '500ml બિલોણા ઘી',
    images: [product2, product1, product3],
    features: ['Family pack', 'Best value', 'Traditional taste'],
    price: 1600,
    size: '500ml',
    popular: true,
    description: 'Our most popular family pack! Perfect balance of quantity and value. Made using traditional Bilona method with pure Gir cow milk.',
    benefits: [
      'Rich in Omega-3 fatty acids',
      'Boosts immunity',
      'Improves digestion',
      'Good for heart health',
      'Enhances brain function'
    ]
  },
  {
    id: 3,
    name: '1L Bilona Ghee',
    gujarati: '1000ml બિલોણા ઘી',
    images: [product3, product1, product2],
    features: ['Best value', 'Long lasting', 'Premium quality'],
    price: 3000,
    size: '1000ml',
    description: 'Best value for money! Our 1L pack is perfect for large families and those who use ghee regularly. Long-lasting and premium quality guaranteed.',
    benefits: [
      'Rich in Omega-3 fatty acids',
      'Boosts immunity',
      'Improves digestion',
      'Good for heart health',
      'Enhances brain function'
    ]
  },
];
